import { render } from "./EventoPage.vue?vue&type=template&id=b5c9189a&scoped=true"
import script from "./EventoPage.vue?vue&type=script&lang=js"
export * from "./EventoPage.vue?vue&type=script&lang=js"

import "./EventoPage.vue?vue&type=style&index=0&id=b5c9189a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c9189a"]])

export default __exports__